import { Editor } from '@tinymce/tinymce-react';
import React, { useState } from 'react';
import ImageUploadPopup from '../../core/utilities/ImageUploadPopup';
import ReportService from '../../core/service/ReportService';

const HTMLEditor = ({ editorRef, initialValue, onContentChange, plugins, toolbar, selectorVal }) => {

  const [imageUploadDialogVisibility, setImageUploadDialogVisibility] = useState(false);
  const isInlineMode = selectorVal !== '#extract' && selectorVal !== '#desc';
  const contentStyle = isInlineMode
    ? '.html-editor-inner-scope p, .html-editor-inner-scope td, .html-editor-inner-scope th, .html-editor-inner-scope span, .html-editor-inner-scope h1, .html-editor-inner-scope h2, .html-editor-inner-scope h3, .html-editor-inner-scope h4, .html-editor-inner-scope h5, .html-editor-inner-scope h6 { font-family: Arial, sans-serif; } .html-editor-inner-scope p, .html-editor-inner-scope td, .html-editor-inner-scope th { font-size: 14px; }'
    : 'body, p, td, th, span, h1, h2, h3, h4, h5, h6 { font-family: Arial, sans-serif; } body, p, td, th { font-size: 14px; }';

  return (
    <>
      <div className="html-editor-inner-scope">
      <Editor
        tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
        onInit={(evt, editor) => editorRef.current = editor}
        initialValue={initialValue}
        onDirty={(e) => {
          onContentChange(e);
        }}
        init={{
          selector: selectorVal,
          // min_height: 590,
          menubar: false,
          branding: false,
          statusbar: false,
          inline: (selectorVal === '#extract' || selectorVal === '#desc') ? false : true,
          // toolbar_sticky: true,
          // ui_mode: 'split',
          plugins: plugins
            ? plugins
            : ['lists', 'code', 'visualblocks', 'table', 'image', 'pagebreak', 'link'],
          toolbar: toolbar
            ? toolbar
            : 'undo redo | formatselect | ' +
            'bold italic forecolor backcolor fontsize fontfamily | alignleft aligncenter ' +
            'alignright alignjustify | link | bullist numlist | lineheight outdent indent pagebreak removeformat ' +
            '| code visualblocks ' +
            '| table media | image insertImage' +
            " charmap emoticons |  ltr rtl",
          // Custom font sizes in px only (TinyMCE 6 uses font_size_formats)
          font_size_formats: '10px 12px 14px 16px 18px 20px 24px 28px 32px 36px 40px',
          font_size_input_default_unit: 'px',
          content_style: contentStyle,
          font_family_formats:
            "Arial=arial,helvetica,sans-serif; Courier New=courier new,courier; Helvetica=helvetica;Symbol=symbol; Times New Roman=times new roman,times;Verdana=verdana,geneva;",
          pagebreak_separator: '<div style="page-break-after: always"></div>',
          paste_data_images: false,
          setup: (editor) => {
            editor.ui.registry.addMenuButton('insertImage', {
              text: 'Insert Image',
              fetch: (callback) => {
                setImageUploadDialogVisibility(true);
                callback([]);
              },
            });
          },
          relative_urls: false,
          remove_script_host: false,
          image_dimensions: false
        }}
      />
      </div>
      {
        imageUploadDialogVisibility &&
        <ImageUploadPopup onPopupClose={(e) => setImageUploadDialogVisibility(false)}
          onImageSelection={(ref) => {
            editorRef.current.insertContent(`<img src='${ReportService.getImage(ref)}'/>`);
            setImageUploadDialogVisibility(false);
          }} />
      }
    </>
  );
}


export default HTMLEditor;